module.exports = __webpack_public_path__ + "static/media/dishub.4f0b604d.png";